// Fiyat kartlari API — /api/item-prices/*.
// NOT: Swagger'da yalnizca POST uclari var (GET listesi yok). Sayfalar bu yuzden
// "gonderim" odakli: yerel olarak girilen satirlar Logo'ya POST edilir.
import { logoRequest } from './client';
import { ensureSession } from './session';
import { ItemSalesPrice, ItemPurchasePrice, LogoResult } from '../types';

/** POST /api/item-prices/sales */
export async function saveSalesPrice(price: ItemSalesPrice): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest({ url: '/api/item-prices/sales', method: 'POST', data: price });
}

/** POST /api/item-prices/sales/bulk */
export async function saveSalesPricesBulk(prices: ItemSalesPrice[]): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest({ url: '/api/item-prices/sales/bulk', method: 'POST', data: prices });
}

/** POST /api/item-prices/purchase */
export async function savePurchasePrice(price: ItemPurchasePrice): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest({ url: '/api/item-prices/purchase', method: 'POST', data: price });
}

/** POST /api/item-prices/purchase/bulk */
export async function savePurchasePricesBulk(prices: ItemPurchasePrice[]): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest({ url: '/api/item-prices/purchase/bulk', method: 'POST', data: prices });
}
